import React, { useState } from 'react';
import { supabase } from '../supabaseClient';

const UploadFile = ({ userId }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) return;

    setUploading(true);

    try {
      const fileType = selectedFile.type.startsWith('image/') ? 'images' : 'documents';
      const filePath = `${userId}/${fileType}/${selectedFile.name}`;

      // Check if the folder exists, if not, create it
      const { data: folderData, error: folderError } = await supabase
        .storage
        .from('Storage')
        .list(userId);

      if (folderError && folderError.message.includes('The resource was not found')) {
        await supabase.storage.from('Storage').createFolder(userId);
        await supabase.storage.from('Storage').createFolder(`${userId}/images`);
        await supabase.storage.from('Storage').createFolder(`${userId}/documents`);
      }

      // Upload the file
      const { error: uploadError } = await supabase
        .storage
        .from('Storage')
        .upload(filePath, selectedFile);

      if (uploadError) {
        throw uploadError;
      }

      alert('File uploaded successfully!');
      setSelectedFile(null);
    } catch (error) {
      console.error('Error uploading file:', error);
      alert('Error uploading file');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div style={{ display:"none" }}>
      <input type="file" onChange={handleFileSelect} accept="image/*,.pdf,.xlsx,.xls,.csv,.docx,.doc,.txt" />
      <button onClick={handleUpload} disabled={uploading || !selectedFile}>
        {uploading ? 'Uploading...' : 'Upload'}
      </button>
    </div>
  );
};

export default UploadFile;
